<template>

<div class="accueil" id="home">   
 
          <p>{{ t('hero_intro') }}</p>
           <h2  class="text-anim" >{{ t('hero_title_line1') }}<br>{{ t('hero_title_line2') }}</h2>
          <div class="cont-btn-home">
            <a href="tel:+33563546609" class="btntxt">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              05 63 54 66 09
            </a>
          </div>
          <div class="Reserv">
          <li><a href="#reservation">{{ t('hero_reservation_link') }}</a></li>
        </div>
 </div>
 
</template>





<script setup>
import { useLocale } from '@/i18n'

const { t } = useLocale()
</script>


<style>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&display=swap');

/* ── Animations hero ─────────────────────────────── */
@keyframes fadeUp {
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
}

.text-anim {
  padding: 10px 0;
  color: #8bbf30;
  font-size: 1.75em;
  text-align: center;
  font-family: 'Playfair Display', serif;
  font-style: italic;
  font-weight: 400;
  animation: fadeUp 0.7s ease 4.8s both;
}
.accueil p {
  color: white;
  font-size: 1.5em;
  width: 100%;
  text-align: center;
  line-height: 1.3;
  font-family: 'Playfair Display', serif;
  font-weight: 400;
  animation: fadeUp 0.7s ease 4.5s both;
}
.Reserv {
  animation: fadeUp 0.7s ease 5.1s both;
  text-decoration: none;
padding: 10px;
font-family: arial;
font-size: 1em;
color: #FFFFFF;
background-color: #8bbf30;
border-radius: 24px;
-webkit-border-radius: 24px;
-moz-border-radius: 24px;
border: 4px solid #FFFFFF;
box-shadow: 3px 3px 12px #444444;
-webkit-box-shadow: 3px 3px 12px #444444;
-moz-box-shadow: 3px 3px 12px #444444;
margin-top: 10px;
list-style-type: none;


}
.Reserv a{
 text-decoration: none;
 color:white;
}
.Reserv:hover {
padding: 10px;
background-color: #899F11;
box-shadow: 1px 1px 4px #777777;
-webkit-box-shadow: 1px 1px 4px #777777;
-moz-box-shadow: 1px 1px 4px #777777;
}
.cont-btn-home {
  display: flex;
  justify-content: center;
  align-items: center;

}

/* numéro téléphone */
.btntxt {
  padding: 1rem 2rem;
  font-size: 1.5rem;
  color: #d3ad7f;
  text-decoration: none;
  letter-spacing: 0.3rem;
  position: relative;
  overflow: hidden;
  animation: titreContentBtn 2s ease-in-out;
  /* margin-left: 12vw; */
  text-align: center;
  white-space: nowrap;
  margin-top: 20px;
  -webkit-animation: titreContentBtn 2s ease-in-out;
}

@keyframes titreContentBtn {
  from {
    opacity: 0;
    transform: translateY(60%);
    -webkit-transform: translateY(60%);
    -moz-transform: translateY(60%);
    -ms-transform: translateY(60%);
    -o-transform: translateY(60%);
  }

  to {
    opacity: 1;
    transform: translateY(0);
    -webkit-transform: translateY(0);
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    -o-transform: translateY(0);
  }
}

.btntxt span {
  position: absolute;
  display: block;
}

.btntxt span:nth-child(1) {
  top: 0;
  left: 0;
  width: 100%;
  height: 0.2rem;
  background: #d3ad7f;
  animation: animate1 3s linear infinite;
}

@keyframes animate1 {
  0% {
    left: -100%;
  }

  50%,
  100% {
    left: 100%;
  }
}

.btntxt span:nth-child(2) {
  top: -100%;
  right: 0;
  width: 2px;
  height: 100%;
  background: #d3ad7f;
  animation: animate2 3s linear infinite;
  animation-delay: 0.75s;
}

@keyframes animate2 {
  0% {
    top: -100%;
  }

  50%,
  100% {
    top: 100%;
  }
}

.btntxt span:nth-child(3) {
  bottom: 0;
  right: -100%;
  width: 100%;
  height: 2px;
  background: #d3ad7f;
  animation: animate3 3s linear infinite;
  animation-delay: 1.5s;
}

@keyframes animate3 {
  0% {
    right: -100%;
  }

  50%,
  100% {
    right: 100%;
  }
}

.btntxt span:nth-child(4) {
  bottom: -100%;
  left: 0;
  width: 2px;
  height: 100%;
  background: #d3ad7f;
  animation: animate4 3s linear infinite;
  animation-delay: 2.25s;
}

@keyframes animate4 {
  0% {
    bottom: -100%;
  }

  50%,
  100% {
    bottom: 100%;
  }
}
@media screen and (max-width: 550px) {
  .accueil {
    height: auto;
  }
  .accueil p {
  font-size: 1.25em;
}
  .text-anim { 
  font-size: 1.25rem;
    }
    h1{
      font-size:1.45rem;
    }
}

</style>